  $(function() {
    var hrefNum = $('.tab_item').length;
    var maxNum = Math.max(hrefNum);
    var mcScrollbar = $(".article-contents-body").mCustomScrollbar({scrollInertia:0});
    // 目次クリックイベント
    $('.article-left li a').on('click', function(event) {
      event.preventDefault();
      var $thisEl = $(this);
      if( isSamePage($thisEl) ) { // ページ内遷移
        // 目次のアクティブを変更
        $('.article-left li a').removeClass('is-active-btn');
        $thisEl.addClass('is-active-btn');
        // 表示位置を変更
        moveArticleContentsBodyTop($thisEl);
      } else {
      // ページ切り替え
        $('.tab_item').removeClass("is-active-item");
        $($thisEl.attr("href")).addClass("is-active-item");
        moveFocusPageTop($thisEl);
        // ページャーを更新
        updatePager();
        // 目次のアクティブを変更
        $('.article-left li a').removeClass('is-active-btn');
        $thisEl.addClass('is-active-btn');
      }
    });

    // ページャークリックイベント
    $('.pager-btn a').on('click', function(event){
      event.preventDefault();
      var $thisEl = $(this);
      var href = $thisEl.attr("href");
      // ページ切り替え
      $('.tab_item').removeClass("is-active-item");
      $(href).addClass("is-active-item");
      moveFocusPageTop($thisEl);
      // ページャーを更新
      updatePager();
      // 目次のアクティブ変更
      $('.article-left li a').removeClass('is-active-btn');
      var targetLeftEl = document.querySelector('.article-left li a[href="'+href+'"]');
      if(targetLeftEl) {
        $(targetLeftEl).addClass('is-active-btn');
      }
    });

    function isSamePage($el) {
      var $focusLink = $('.is-active-btn');
      return $el.attr('href') === $focusLink.attr('href');
    }
    /**
     * ページの初期表示位置へ移動
     */
     function moveFocusPageTop($el) {
      // TOPへ移動
      $('body,html').animate({scrollTop:0}, 0.5, 'swing');
      moveArticleContentsBodyTop($el);
    }
    /**
     * 表示コンテンツの表示位置へ移動
     */
    function moveArticleContentsBodyTop($el) {
      var subHref = $el.attr('data-subHref');
      var contentBodyTop = 0;
      var param = {
        scrollInertia: 0.5,
      }
      if(subHref && subHref.indexOf('-1') === -1) {
        var targetEl = $('#'+subHref);
        if(targetEl.length) {
          var parentContentTop = $($el.attr('href')).offset().top
          var top = Math.ceil(targetEl.offset().top) || 0;
          var type = top > 0 ? '-=' : '+=';
          contentBodyTop = top > 0 ? top - parentContentTop : Math.abs(parentContentTop) - Math.abs(top);
        }
      }

      mcScrollbar.mCustomScrollbar("scrollTo",contentBodyTop,param);
    }
    /**
     * ページャーを更新
    */
    function updatePager() {
      var mainID = $('.is-active-item').attr('id');
      var nextID = '#' + (parseInt(mainID) + 1);
      var prevID = '#' + (parseInt(mainID) - 1);
      $('.next a').attr('href',nextID);
      $('.prev a').attr('href',prevID);

      if(mainID == maxNum){
        $('.next a').addClass('disabled');
      }else{
        $('.next a').removeClass('disabled');
      }
      if(mainID == 1){
        $('.prev a').addClass('disabled');
      }else{
        $('.prev a').removeClass('disabled');
      }
    }
    return false;
  });
